<template>
	<div class="tpl edit-info-wrap" @click="hideOption">
		<mt-header title="编辑个人资料" fixed>
			<router-link :to="{name:'my-page-mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button slot="right" @click.native="submitInfo">保存</mt-button>
		</mt-header>
		<!--<div class="percent">
			<span class="percent-inner" style="width: 80%;"></span>
			<span class="percent-num">资料完成度：80%</span>
		</div>-->
		<div class="info-list">
			<p class="list-title">基本资料</p>
			<ul>
				<li>
					<span class="name">ID</span>
					<div class="value">
						<span class="text">{{userInfo.uid}}</span>
						<span class="option"></span>
					</div>
				</li>
				<li>
					<span class="name">身高</span>
					<div class="value" @click.stop="chooseHeight()">
						<span class="text">{{userInfo.height}}CM</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">昵称</span>
					<div class="value" @click.stop="setNickname">
						<span class="text">{{userInfo.nickname}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">性别</span>
					<div class="value">
						<span class="text">{{userInfo.gender==1?"男":"女"}}</span>
						<span class="option">不可修改</span>
					</div>
				</li>
				<li>
					<span class="name">生日</span>
					<div class="value" @click.stop="setBirthday">
						<span class="text">{{userInfo.birthday}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">学历</span>
					<div class="value" @click.stop="setEdu(1)">
						<span class="text">{{userInfo.education|educationFormat}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">年收入</span>
					<div class="value" @click.stop="setIncome(1)">
						<span class="text">{{userInfo.annual_income}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">所在地</span>
					<div class="value" @click.stop="selectAdd(1)">
						<span class="text">{{userInfo.city}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
			</ul>
		</div>
		<div class="info-list">
			<p class="list-title">高级资料</p>
			<ul>
				<li>
					<span class="name">购房情况</span>
					<div class="value" @click="userInfo.is_house&&houseCerti">
						<span class="text"></span>
						<span class="option">{{userInfo.is_house==0?"未认证":"已认证"}}<img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">购车情况</span>
					<div class="value" @click="userInfo.is_vehicle&&carCerti">
						<span class="text"></span>
						<span class="option">{{userInfo.is_vehicle==0?"未认证":"已认证"}}<img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">婚姻</span>
					<div class="value" @click.stop="setMarriage">
						<span class="text">{{userInfo.marriage}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">宗教</span>
					<div class="value" @click.stop="setReligion">
						<span class="text">{{userInfo.religion}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">子女</span>
					<div class="value" @click.stop="setChild">
						<span class="text">{{userInfo.children}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
			</ul>
		</div>
		<div class="info-list">
			<p class="list-title">择偶标准</p>
			<ul>
				<li>
					<span class="name">年龄</span>
					<div class="value" @click.stop="setAges()">
						<span class="text">{{selectRules.love_age}}岁</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">身高</span>
					<div class="value" @click.stop="chooseHeights()">
						<span class="text">{{selectRules.love_height}}CM</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">学历</span>
					<div class="value" @click.stop="setEdu(2)">
						<span class="text">{{selectRules.love_education}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">年收入</span>
					<div class="value" @click.stop="setIncome(2)">
						<span class="text">{{selectRules.annual_income}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
				<li>
					<span class="name">居住地</span>
					<div class="value" @click.stop="selectAdd(2)">
						<span class="text">{{selectRules.love_address}}</span>
						<span class="option"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
					</div>
				</li>
			</ul>
		</div>
		<transition name="fade">
			<mt-picker :slots="heightOptions" @change="setHeight" v-show="showChooseHeight"></mt-picker>
		</transition>
		<transition name="fade">
			<mend-nickname v-if="showMendNickname" :uid="uid" title="修改昵称" :text="userInfo.nickname" @closeMend="closeMend"></mend-nickname>
		</transition>
		<transition name="fade">
			<mt-datetime-picker ref="chooseBirthday" :startDate="startDate" type="date" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="dateConfirm"></mt-datetime-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="eduOptions" value-key="name" @change="chooseEdu" v-show="showChooseEdu"></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="incomeOptions" @change="chooseIncome" value-key="name" v-show="showChooseIncome"></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="addressList" @change="setAdd" value-key="name" v-show="chooseAdd" fixed></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="marriageList" @change="chooseMarriage" value-key="name" v-show="showChooseMarriage" fixed></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="religionList" @change="chooseReligion" value-key="name" v-show="showChooseReligion" fixed></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="childList" @change="chooseChild" value-key="name" v-show="showChooseChild" fixed></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="heightsOptions" @change="setHeights" v-show="showChooseHeights"></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="agesOptions" @change="chooseAges" v-show="showChooseAges"></mt-picker>
		</transition>
	</div>
</template>

<script>
	import Moment from "moment"
	import MendNickname from "./MendNickname"
	export default{
		name:"edit-personal-info",
		components:{
			MendNickname
		},
		data() {
			return {
				uid: "",
				userInfo:"",
				selectRules:"",
				showChooseHeight: false,
				showChooseHeights: false,
				showMendNickname:0,
				startDate:new Date(0),
				showChooseEdu:false,
				eduStatus:"",
				showChooseIncome:false,
				incomeStatus:"",
				incomeIdSelf:"",
				incomeIdOther:"",
				chooseAdd: false,
				addStatus:"",
				provId: "",
				cityIdSelf: "",
				cityIdOther: "",
				firstSelect: true,
				addressList: [{
					flex: 1,
					values: [],
					className: 'slot1',
					textAlign: 'center'
				}, {
					divider: true,
					content: '-',
					className: 'slot2'
				}, {
					flex: 1,
					values: [],
					className: 'slot3',
					textAlign: 'center'
				}],
				showChooseMarriage:false,
				marriageList: [{
					flex: 1,
					values: ["未婚","已婚","离异"],
					className: 'slot1',
					textAlign: 'center'
				}],
				showChooseReligion:false,
				religionList: [{
					flex: 1,
					values: ["无","佛教","道教","基督教","伊斯兰教"],
					className: 'slot1',
					textAlign: 'center'
				}],
				showChooseChild:false,
				childList: [{
					flex: 1,
					values: ["无","有"],
					className: 'slot1',
					textAlign: 'center'
				}],
				showChooseAges:false,
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getInfo();
			
		},
		filters:{
			educationFormat(data){
				switch(data){
					case "1":
						return "大专以下";
						break;
					case "2":
						return "大专";
						break;
					case "3":
						return "本科";
						break;
					case "4":
						return "硕士";
						break;
					case "5":
						return "博士";
						break;
					case "6":
						return "海外留学";
						break;
				}
			}
		},
		computed: {
			showTel() {
				let t = this.tel.substr(0, 3) + "****" + this.tel.substr(7);
				return t;
			},
			heightOptions() {
				let arr = [];
				for(let i = 140; i <= 220; i++) {
					arr.push(i)
				}
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 30
				}, ]
				return obj;
			},
			incomeOptions() {
				let arr = [{
						name: "3W以下",
						id: 1
					},
					{
						name: "3W-5W",
						id: 2
					},
					{
						name: "5W-8W",
						id: 3
					},
					{
						name: "8W-10W",
						id: 4
					},
					{
						name: "10W-15W",
						id: 5
					},
					{
						name: "15W-20W",
						id: 6
					},
					{
						name: "20W以上",
						id: 7
					},
				];
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center'
				}, ]
				return obj;
			},
			eduOptions() {
				let arr = [{
						name: "大专以下",
						id: 1
					},
					{
						name: "大专",
						id: 2
					},
					{
						name: "本科",
						id: 3
					},
					{
						name: "硕士",
						id: 4
					},
					{
						name: "博士",
						id: 5
					},
					{
						name: "海外留学",
						id: 6
					},
				];
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 2
				}, ]
				return obj;
			},
			heightsOptions() {
				let arr = [];
				for(let i = 140; i <= 220; i++) {
					arr.push(i)
				}
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 30
				}, {
					divider: true,
					content: '-',
					className: 'slot2'
				}, {
					flex: 1,
					values: arr,
					className: 'slot3',
					textAlign: 'center',
					defaultIndex: 30
				} ]
				return obj;
			},
			agesOptions() {
				let arr = [];
				for(let i = 18; i <= 60; i++) {
					arr.push(i)
				}
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 2
				}, {
					divider: true,
					content: '-',
					className: 'slot2'
				}, {
					flex: 1,
					values: arr,
					className: 'slot3',
					textAlign: 'center',
					defaultIndex: 22
				} ]
				return obj;
			},
		},
		methods:{
			hideOption(){
				this.showChooseHeight = false;
				this.showChooseHeights = false;
				this.showMendNickname = 0;
				this.showChooseEdu = false;
				this.showChooseIncome = false;
				this.chooseAdd = false;
				this.showChooseMarriage = false;
				this.showChooseReligion = false;
				this.showChooseChild = false;
				this.showChooseAges = false;
			},
			getInfo(){
				this.$axios({
					url:"My/PersonalInfo",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.userInfo = res.data.data.info;
						this.selectRules = res.data.data.selection;
						console.log(this.selectRules)
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			chooseHeight(){
				this.hideOption();
				this.showChooseHeight = true;
			},
			setHeight(index, value) {
				if(this.userInfo.height){
					this.userInfo.height = value[0]
				}
			},
			chooseHeights(){
				this.hideOption();
				this.showChooseHeights = true;
			},
			setHeights(index, value) {
				if(this.selectRules){
					this.selectRules.love_height = value[0]+"-"+value[1]
				}
			},
			setNickname(){
				this.hideOption();
				this.showMendNickname=1;
			},
			closeMend(s){
				if(s==0){
					this.showMendNickname = 0;
				}else{
					this.showMendNickname = 0;
					this.getBaseInfo();
				}
			},
			setBirthday(){
				this.hideOption();
				this.$refs.chooseBirthday.open();
			},
			dateConfirm(date){
				this.userInfo.birthday = Moment(date).format("YYYY-MM-DD");
			},
			setEdu(s){
				this.hideOption();
				this.showChooseEdu = true;
				this.eduStatus = s;
			},
			chooseEdu(index, value) {
				if(this.eduStatus==1&&this.userInfo.education){
					this.userInfo.education = value[0].name;
				}else if(this.eduStatus==2&&this.userInfo.education){
					this.selectRules.love_education = value[0].name;
				}
			},
			setIncome(s){
				this.hideOption();
				this.showChooseIncome = true;
				this.incomeStatus = s;
			},
			chooseIncome(index, value) {
				if(this.incomeStatus==1&&this.userInfo){
					this.userInfo.annual_income = value[0].name;
					this.incomeIdSelf = value[0].id;
				}else if(this.incomeStatus==2&&this.selectRules){
					this.selectRules.annual_income = value[0].name;
					this.incomeIdOther = value[0].id;
				}
			},
			selectAdd(s) {
				this.hideOption();
				this.addStatus = s;
				this.chooseAdd = !this.chooseAdd;
				this.getAddressInfo(1, {
					success: (res) => {
						this.addressList[0].values = res
					}
				})
			},
			getAddressInfo(id, options) {
				this.$axios({
					url: "Currency/getRegionInfoList",
					method: "post",
					data: {
						region_id: id,
					}
				}).then(res => {
					if(res.data.code == 200) {
						let a = res.data.data.map(function(item) {
							let obj = {};
							obj.name = item.region_name;
							obj.id = item.region_id;
							return obj;
						})
						console.log(a);
						if(!!options && !!options.success) {
							options.success(a)
						}
					}
				}).catch(err => {
					console.log(err)
				})

			},
			setAdd(picker, value) {
				if(value[0]) {
					this.provId = value[0].id;
					this.getAddressInfo(value[0].id, {
						success: (res) => {
							picker.setSlotValues(1, res);
						}
					})
					if(value[1]) {
						console.log(value[1].id);
						if(this.addStatus==1){
							this.cityIdSelf = value[1].id;
							this.userInfo.city = value[0].name+"-"+value[1].name;
						}else if(this.addStatus==2){
							this.cityIdOther = value[1].id;
							this.selectRules.love_address = value[0].name+"-"+value[1].name;
						}
						
					}
				}
			},
			houseCerti(){
				this.$router.push({
					name:"cert-house"
				})
			},
			carCerti(){
				this.$router.push({
					name:"cert-house"
				})
			},
			setMarriage(){
				this.hideOption();
				this.showChooseMarriage = true;
			},
			chooseMarriage(index, value){
				if(this.userInfo.marriage){
					this.userInfo.marriage = value[0];
				}
			},
			setReligion(){
				this.hideOption();
				this.showChooseReligion = true;
			},
			chooseReligion(index, value){
				if(this.userInfo.religion){
					this.userInfo.religion = value[0];
				}
			},
			setChild(){
				this.hideOption();
				this.showChooseChild = true;
			},
			chooseChild(index, value){
				if(this.userInfo.children){
					this.userInfo.children = value[0];
				}
			},
			setAges(){
				this.hideOption();
				this.showChooseAges = true;
			},
			chooseAges(index, value){
				if(this.selectRules){
					this.selectRules.love_age = value[0]+"-"+value[1];
				}
			},
			submitInfo(){
				let data = {
					uid:this.uid,
					age:this.userInfo.birthday,
					height:this.userInfo.height,
					nickname:this.userInfo.nickname,
					education:this.userInfo.education,
					annual_income:this.incomeIdSelf,
					city:this.cityIdSelf,
					marriage:this.userInfo.marriage,
					religion:this.userInfo.religion,
					children:this.userInfo.children,
					love_age:this.selectRules.love_age,
					love_height:this.selectRules.love_height,
					love_education:this.selectRules.love_education,
					love_annual_income:this.incomeIdOther,
					love_address:this.cityIdOther
				}
				this.$axios({
					url:"My/EditingMaterials",
					method:"post",
					data:data,
				}).then(res=>{
					console.log(res);
					this.$toast({
						message: res.data.msg,
						position: "bottom",
						duration: 2000
					})
					if(res.data.code==200){
						this.$router.push({name:"my-page-mine"})
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	>>>.mint-button-text{
		color: #5415F9;
	}
	>>>.picker-item{
		font-size: 0.8rem;
	}
	.picker{
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		background: linear-gradient(to bottom,rgba(255,255,255,.8),#fff);
		border-top: 1px solid #f3f3f3;
	}
	.edit-info-wrap{
		padding-top: 2.5rem;
		padding-bottom: 30vh;
	}
	.percent{
		width: 100%;
		height: 1.5rem;
		font-size: 0.65rem;
		line-height: 1.5rem;
		color: #fff;
		position: relative;
		padding: 0 1rem;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	.percent .percent-inner{
		height: 100%;
		border-radius: 0 1rem 1rem 0;
		background: #5415F9;
		position: absolute;
		top: 0;
		left: 0;
	}
	.percent .percent-num{
		position: relative;
		z-index: 1;
	}
	.info-list{
		background: #fff;
	}
	.info-list .list-title{
		font-size: 0.95rem;
		color: #282828;
		font-weight: bold;
		padding: 0.5rem 1rem;
	}
	.info-list ul{
		border-top: 1px solid #f3f3f3;
		margin-bottom: 1px;
		padding-left: 1.5rem;
	}
	.info-list li{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0.3rem 1rem 0.3rem 0.3rem;
		border-bottom: 1px solid #f3f3f3;
		font-size: 0.8rem;
		color: #686868;
		height: 2.2rem;
	}
	.info-list li:last-of-type{
		border-bottom: 0;
	}
	.info-list li .name{
		width: 4rem;
	}
	.info-list li .value{
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.info-list li .value .option{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.7rem;
		color: #bdbdbd;
	}
	.info-list li .value img{
		width: 1.5rem;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/EditPersonalInfo.vue